/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Formik } from 'formik';
import dayjs from 'dayjs';

import { ValidationCreateEvent, ValidationEditEvent } from 'common/validations';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import TextIput from 'components/form/textInput';
import FieldPair from 'components/form/fieldPair';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import DateInput from 'components/form/dateInput';
import UploadBox from 'components/form/uploadBox';
import { EventTypeEnumArray } from 'common/enums';
import Dropdown from 'components/form/dropDown';
import TextArea from 'components/form/texArea';
import EventFormGuestsList from './lib/guestsList';
import AppSwitch from 'components/form/switch';
import DangerButton from 'components/form/buttons/danger';
import QuestionModal from 'components/modal/question';
import { toast } from 'common/helpers/toastConfig';

import * as S from '../../styles';
import * as T from 'common/types';

interface IProps {
  data?: T.Pages.EventItem;
  departments: string[];
  closeModal?: () => void;
  fetchData?: () => void;
  loading: boolean;
}

/*
 * The longest form in the product, and until now one narrow Bootstrap column
 * of fourteen unrelated fields with the guest list beside it — department next
 * to nothing, three date pickers in a row with no heading over them, and the
 * cover uploader at the bottom of the stack.
 *
 * It is four sections now, each a card with the design's section head, and
 * every row inside them is two or three columns wide. The order follows what
 * the author is deciding rather than what the payload happens to list: what
 * the event is, when and where it happens, what it looks like, who is
 * speaking.
 */
const EventForm: React.FC<IProps> = ({ data, departments, loading }) => {
  const nav = useNavigate();
  const params = useParams();

  const [ShowCanceleModal, setShowCanceleModal] = useState(false);

  const {
    eventCreateRequestAction,
    eventUpdateRequestAction,
    eventUploadRequestAction,
    departmentsRequestAction,
    eventCancelRequestAction,
    eventDetailRequestAction,
    eventChangeVisibleRequestAction
  } = useActions();

  useEffect(() => {
    departmentsRequestAction();
  }, []);

  const handleShowCancelModal = () => {
    setShowCanceleModal(true);
  };

  const handleHideCancelModal = () => {
    setShowCanceleModal(false);
  };

  const handleCancelEvent = () => {
    eventCancelRequestAction(data?.id, () => {
      setShowCanceleModal(false);
      nav('/panel/events');
    });
  };

  const handleChangeVisible = () => {
    eventChangeVisibleRequestAction(data?.id, () => {
      eventDetailRequestAction(params?.id);
    });
  };

  return (
    <>
      <Formik
        initialValues={{
          en_title: data?.eventTranslations?.find((t: any) => t.language === 'en')?.title || '',
          ar_title: data?.eventTranslations?.find((t: any) => t.language === 'ar')?.title || '',
          type: data?.type || '',
          department: data?.department || '',
          cover: '',
          startsAt: data?.startsAt || '',
          startSign: data?.startSign || '',
          endSign: data?.endSign || '',
          id: data?.id || undefined,
          en_description: data?.eventTranslations?.find((t: any) => t.language === 'en')?.description || '',
          ar_description: data?.eventTranslations?.find((t: any) => t.language === 'ar')?.description || '',
          image: undefined,
          fileUrl: data?.image || '',
          capacity: data?.capacity || '',
          duration: data?.duration || '',
          eventPlace: data?.eventPlace || '',
          guestsList: data?.guests || [],
          // isDisable: false,
          isPublic: data?.isPublic || false
        }}
        enableReinitialize
        validationSchema={data?.id ? ValidationEditEvent : ValidationCreateEvent}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          if (new Date(values.startSign) > new Date(values.startsAt)) {
            toast({
              model: 'error',
              message: 'The registration date cannot be older than the start date'
            });
            setSubmitting(false);
            return;
          }
          let flag = 0;
          let flagLinkdin = 0;
          let flagWeblink = 0;

          const expression =
            // eslint-disable-next-line no-useless-escape
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
          const regex = new RegExp(expression);

          values.guestsList.map((item: any) => {
            if (!item.fullName || !item.jobTitle || !item.description) {
              flag += 1;
            }
            if (!item.weblink.match(regex) && item.weblink) {
              flagWeblink += 1;
            }
            if (!item.linkedin.match(regex) && item.linkedin) {
              flagLinkdin += 1;
            }
          });
          if (flagWeblink > 0) {
            toast({
              message: `The website link format is wrong`,
              model: 'error'
            });
            setSubmitting(false);
            return;
          }
          if (flagLinkdin > 0) {
            toast({
              message: `The linkedin link format is wrong`,
              model: 'error'
            });
            setSubmitting(false);
            return;
          }
          if (flag !== 0) {
            toast({
              model: 'error',
              message: 'Full name, job title, Description fields are required'
            });
            setSubmitting(false);
            return;
          }
          const newData = {
            type: values.type,
            cover: values.cover || undefined,
            startsAt: values.startsAt,
            duration: values.duration,
            capacity: values.capacity,
            eventPlace: values.eventPlace,
            department: values.department,
            startSign: values.startSign,
            endSign: values.endSign,
            id: data?.id || undefined,
            isPublic: values.isPublic,
            translations: [
              {
                title: values.en_title,
                description: values.en_description,
                language: 'en'
              },
              {
                title: values.ar_title,
                description: values.ar_description,
                language: 'ar'
              }
            ],
            guestsList: values.guestsList.map((item) => {
              return {
                avatar: item.avatar,
                description: item.description,
                fullName: item.fullName,
                jobTitle: item.jobTitle,
                linkedin: item.linkedin,
                weblink: item.weblink,
                id: item.id
              };
            })
          };
          if (data?.id)
            eventUpdateRequestAction(newData, () => {
              resetForm();
              nav('/panel/events');
            });
          else
            eventCreateRequestAction(newData, () => {
              resetForm();
              nav('/panel/events');
            });
          setSubmitting(false);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setValues }) => (
          <S.Stack>
            {/*
             * Visibility lives in the section head, the way Active does on
             * Menu Details and Create Customization — it is a property of the
             * whole record, not a field in the middle of the stack.
             */}
            <PanelBoxLayout
              title="Event details"
              info={
                <S.Switches>
                  <AppSwitch
                    theme="two"
                    checked={values.isPublic}
                    onChange={(e) => setValues({ ...values, isPublic: e })}
                    text="Public event"
                  />
                  {data?.id ? (
                    <AppSwitch
                      theme="two"
                      checked={data?.isDisable}
                      onChange={() => handleChangeVisible()}
                      text="Hidden"
                    />
                  ) : (
                    <></>
                  )}
                </S.Switches>
              }
            >
              <S.Rows>
                <S.Grid2>
                  <Dropdown
                    list={departments?.map((item: string) => {
                      return { id: item, title: item };
                    })}
                    onChange={(e: T.Form.ListDropdownItem) => {
                      setValues({
                        ...values,
                        department: e.id as string
                      });
                    }}
                    label="Department"
                    placeholder="Select a department"
                    defaultValue={{
                      title: values.department,
                      id: values.department
                    }}
                    message={touched.department && (errors.department as any)}
                    error={touched.department && (errors.department as unknown as boolean)}
                  />

                  <Dropdown
                    label="Type"
                    placeholder="Select a type"
                    list={EventTypeEnumArray}
                    onChange={(e: T.Form.ListDropdownItem) => {
                      setValues({
                        ...values,
                        type: e.id as string
                      });
                    }}
                    defaultValue={{ title: values.type, id: values.type }}
                    message={touched.type && (errors.type as any)}
                    error={touched.type && (errors.type as unknown as boolean)}
                  />
                </S.Grid2>

                <FieldPair>
                  <TextIput
                    type="text"
                    name="en_title"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Event title"
                    label="Title"
                    langTag="EN"
                    required
                    value={values.en_title}
                    message={touched.en_title && (errors.en_title as any)}
                    error={touched.en_title && (errors.en_title as unknown as boolean)}
                  />
                  <TextIput
                    type="text"
                    name="ar_title"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="عنوان الفعالية"
                    label="Title"
                    langTag="AR"
                    required
                    dir="rtl"
                    value={values.ar_title}
                    message={touched.ar_title && (errors.ar_title as any)}
                    error={touched.ar_title && (errors.ar_title as unknown as boolean)}
                  />
                </FieldPair>

                <FieldPair>
                  <TextArea
                    label="Description"
                    langTag="EN"
                    name="en_description"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="What is this event about?"
                    value={values.en_description}
                    message={touched.en_description && (errors.en_description as any)}
                    error={touched.en_description && (errors.en_description as unknown as boolean)}
                  />
                  <TextArea
                    label="Description"
                    langTag="AR"
                    dir="rtl"
                    name="ar_description"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="وصف الفعالية"
                    value={values.ar_description}
                    message={touched.ar_description && (errors.ar_description as any)}
                    error={touched.ar_description && (errors.ar_description as unknown as boolean)}
                  />
                </FieldPair>
              </S.Rows>
            </PanelBoxLayout>

            {/*
             * Three dates and three facts about the room, on two rows of
             * three. They used to be six full-width controls in a column, so
             * "starts at" and "registration closes" were a screen apart.
             */}
            <PanelBoxLayout title="When and where" hint="Registration must open before the event starts">
              <S.Rows>
                <S.Grid3>
                  <DateInput
                    onChange={(e) => {
                      setValues({
                        ...values,
                        startsAt: e
                      });
                    }}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY MMMM D HH:mm"
                    placeholder="Pick a date and time"
                    label="Event starts"
                    defaultDate={values.startsAt && dayjs(values.startsAt)}
                    message={touched.startsAt && (errors.startsAt as any)}
                    error={touched.startsAt && (errors.startsAt as unknown as boolean)}
                  />
                  <DateInput
                    onChange={(e) => {
                      setValues({
                        ...values,
                        startSign: e
                      });
                    }}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY MMMM D HH:mm"
                    placeholder="Pick a date and time"
                    label="Registration opens"
                    defaultDate={values.startSign && dayjs(values.startSign)}
                    message={touched.startSign && (errors.startSign as any)}
                    error={touched.startSign && (errors.startSign as unknown as boolean)}
                  />
                  <DateInput
                    onChange={(e) => {
                      setValues({
                        ...values,
                        endSign: e
                      });
                    }}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY MMMM D HH:mm"
                    placeholder="Pick a date and time"
                    label="Registration closes"
                    defaultDate={values.endSign && dayjs(values.endSign)}
                    key={values.endSign}
                    message={touched.endSign && (errors.endSign as any)}
                    error={touched.endSign && (errors.endSign as unknown as boolean)}
                  />
                </S.Grid3>

                <S.Grid3>
                  <TextIput
                    type="text"
                    label="Place"
                    placeholder="Where is it held?"
                    name="eventPlace"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.eventPlace}
                    message={touched.eventPlace && (errors.eventPlace as any)}
                    error={touched.eventPlace && (errors.eventPlace as unknown as boolean)}
                  />
                  <TextIput
                    label="Duration"
                    placeholder="e.g. 2h"
                    name="duration"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.duration}
                    message={touched.duration && (errors.duration as any)}
                    error={touched.duration && (errors.duration as unknown as boolean)}
                  />
                  <TextIput
                    type="number"
                    arrow
                    label="Capacity"
                    placeholder="How many people?"
                    name="capacity"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.capacity as string}
                    message={touched.capacity && (errors.capacity as any)}
                    error={touched.capacity && (errors.capacity as unknown as boolean)}
                  />
                </S.Grid3>
              </S.Rows>
            </PanelBoxLayout>

            <PanelBoxLayout title="Cover photo" hint="Shown at the top of the event in the employee app">
              <S.Dropzone>
                <UploadBox
                  placeholder="Drop an image here, or click to choose one"
                  ratio="1.7 : 1"
                  onChange={(e: T.Form.FileUpload) => {
                    eventUploadRequestAction({ image: e?.file }, (fileNameOnly: string) => {
                      setValues({
                        ...values,
                        cover: fileNameOnly,
                        fileUrl: e.dataURL
                      });
                    });
                  }}
                  message={touched.image && (errors.image as any)}
                  error={touched.image && (errors.image as any)}
                  key={data?.id}
                  defaultImage={values.fileUrl}
                  value={{ file: values.image, dataURL: values.fileUrl }}
                />
              </S.Dropzone>
            </PanelBoxLayout>

            <EventFormGuestsList setValues={setValues} values={values} />

            <S.Actions>
              {data?.id ? <DangerButton onClick={handleShowCancelModal}>Cancel event</DangerButton> : <></>}
              <S.Spacer />
              <OutlineButton link="/panel/events">Back</OutlineButton>
              <PrimaryButton onClick={handleSubmit} disabled={loading || isSubmitting}>
                {data?.id ? 'Save event' : 'Create event'}
              </PrimaryButton>
            </S.Actions>
          </S.Stack>
        )}
      </Formik>
      <QuestionModal
        handleClose={handleHideCancelModal}
        show={ShowCanceleModal}
        model="delete"
        handleSuccess={handleCancelEvent}
        title="Cancel this event?"
        text="Everyone registered for it is told it is off. This cannot be undone."
        successButtonText="Cancel event"
      />
    </>
  );
};

export default EventForm;
